import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../commonComponents/Buttons";

import "./confirmationModal.scss";

function ConfirmationModal({
  setConfirmationModal,
  modalTitle,
  modalLegend,
  modalConfirmBtn,
  deleteFunction,
  neededInfo,
}) {
  const { t } = useTranslation();
  return (
    <>
      <section className="modalBg">
        <section className="modalBody confirmationModal">
          <div className="dialog-header">
            <h3 className="heading-3">{modalTitle}</h3>
            <legend>{modalLegend}</legend>
          </div>

          <div className="buttons dialog-footer">
            <Button
              label={t("cancel")}
              viewType="cancelBtn"
              onClick={() => setConfirmationModal(false)}
            />
            <Button
              label={modalConfirmBtn}
              viewType="removeBtn"
              onClick={() => {
                if (neededInfo) {
                  deleteFunction(neededInfo);
                } else {
                  deleteFunction();
                }
              }}
            />
          </div>
          <Button
            iconClassName="hasIcon--close"
            viewType="transparentIcon"
            onClick={() => setConfirmationModal(false)}
          />
        </section>
      </section>
    </>
  );
}

export default ConfirmationModal;
